export const GROUP_ROW_SELECT = 'id, name, event_id, access_type, status, archived_at, created_at';

export const GROUP_EVENT_SELECT =
  'event_id, event_name, event_type, display_name, display_name_override, event_datetime, event_date, ends_at, multi_day, event_time, genre, hero_image_url, card_image_url, event_url, venues(id, name, venue_tier, demo_priority, address, city, state, is_la_market)';

export const GROUP_MEMBERS_SELECT = `
  *,
  profiles:user_id(id, display_name, profile_photo_url)
`;

export function isDbUuid(value) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    String(value || ''),
  );
}

export function formatGroupMemberDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function mapMembersRows(rows) {
  return (rows || []).map((m) => ({
    ...m,
    profile: m.profiles,
  }));
}

export function buildEventForCard(event, eventRsvpGoingCount) {
  if (!event) return null;
  let venues = event.venues;
  if (Array.isArray(venues) && venues.length > 0) {
    venues = venues[0];
  }
  return {
    ...event,
    venues,
    rsvp_going_count: eventRsvpGoingCount,
  };
}
